import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.join.js";
import form from '@/mixins/crud-form';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'MENU_DETAIL',
        create: 'MENU_CREATE',
        update: 'MENU_UPDATE'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      var menuName = {
        prop: 'menu_name',
        default: '',
        label: '菜单名称',
        rule: {
          required: true,
          message: '必填',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.menu_name,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "menu_name", $$v);
              }
            }
          });
        }
      };
      var parentId = {
        prop: 'parent_id',
        default: 0,
        label: '上级菜单',
        render: function render() {
          return h("d2-tree-popover", {
            "attrs": {
              "source": "MENU_ALL",
              "key-label": "menu_name"
            },
            "model": {
              value: _this.form.model.parent_id,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "parent_id", $$v);
              }
            }
          });
        }
      };
      var menuType = {
        prop: 'menu_type',
        default: this.$env.VUE_APP_DICT_MENU_TYPE_MENU,
        label: '菜单类型',
        render: function render() {
          return h("d2-dict-radio", {
            "attrs": {
              "name": "menu_type",
              "button": true
            },
            "on": {
              "change": _this.onMenuTypeChange
            },
            "model": {
              value: _this.form.model.menu_type,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "menu_type", $$v);
              }
            }
          });
        }
      };
      var orderNum = {
        prop: 'order_num',
        default: this.$env.VUE_APP_FORM_SORT_MIN,
        label: '显示排序',
        render: function render() {
          return h("el-input-number", {
            "attrs": {
              "min": _this.$env.VUE_APP_FORM_SORT_MIN
            },
            "model": {
              value: _this.form.model.order_num,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "order_num", $$v);
              }
            }
          });
        }
      };
      var url = {
        prop: 'url',
        default: '',
        label: '菜单链接',
        render: function render() {
          return h("el-input", {
            "attrs": {
              "placeholder": "/foo/path?key=value",
              "clearable": true
            },
            "on": {
              "input": _this.onUrlChange
            },
            "model": {
              value: _this.form.model.url,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "url", $$v);
              }
            }
          });
        }
      };
      var routeName = {
        prop: 'route_name',
        default: '',
        label: '路由名称',
        render: function render() {
          return h("el-input", {
            "attrs": {
              "placeholder": "foo-path",
              "clearable": true
            },
            "model": {
              value: _this.form.model.route_name,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "route_name", $$v);
              }
            }
          });
        }
      };
      var routePath = {
        prop: 'route_path',
        default: '',
        label: '路由地址',
        render: function render() {
          return h("el-input", {
            "attrs": {
              "placeholder": "foo/path",
              "clearable": true
            },
            "model": {
              value: _this.form.model.route_path,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "route_path", $$v);
              }
            }
          });
        }
      };
      var routeComponent = {
        prop: 'route_component',
        default: '',
        label: '路由组件',
        render: function render() {
          return h("el-input", {
            "attrs": {
              "placeholder": "foo/path",
              "clearable": true
            },
            "model": {
              value: _this.form.model.route_component,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "route_component", $$v);
              }
            }
          });
        }
      };
      var routeCache = {
        prop: 'route_cache',
        default: this.$env.VUE_APP_DICT_IS_FALSE,
        label: '路由缓存',
        render: function render() {
          return h("d2-dict-radio", {
            "attrs": {
              "name": "is",
              "button": true
            },
            "model": {
              value: _this.form.model.route_cache,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "route_cache", $$v);
              }
            }
          });
        }
      };
      var perms = {
        prop: 'perms',
        default: '',
        label: '权限标识',
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.perms,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "perms", $$v);
              }
            }
          });
        }
      };
      var icon = {
        prop: 'icon',
        default: '',
        label: '图标',
        render: function render() {
          return h("d2-icon-select", {
            "model": {
              value: _this.form.model.icon,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "icon", $$v);
              }
            }
          });
        }
      };
      var visible = {
        prop: 'visible',
        default: 1,
        label: '可见性',
        render: function render() {
          return h("d2-dict-radio", {
            "attrs": {
              "name": "visible",
              "button": true
            },
            "model": {
              value: _this.form.model.visible,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "visible", $$v);
              }
            }
          });
        }
      };
      var isFrame = {
        prop: 'is_frame',
        default: this.$env.VUE_APP_DICT_IS_FALSE,
        label: '外链',
        render: function render() {
          return h("d2-dict-radio", {
            "attrs": {
              "name": "is",
              "button": true
            },
            "model": {
              value: _this.form.model.is_frame,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "is_frame", $$v);
              }
            }
          });
        }
      };
      var remark = {
        prop: 'remark',
        default: '',
        label: '备注',
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.remark,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "remark", $$v);
              }
            }
          });
        }
      };
      return [parentId, menuName, menuType].concat(_toConsumableArray(this.form.model.menu_type === this.$env.VUE_APP_DICT_MENU_TYPE_MENU ? [icon, isFrame, url, routeName, routePath, routeComponent, routeCache, perms, visible] : []), _toConsumableArray(this.form.model.menu_type === this.$env.VUE_APP_DICT_MENU_TYPE_BUTTON ? [perms] : []), [orderNum, remark]);
    }
  },
  methods: {
    /**
     * @description 菜单类型改变时重新计算表单
     */
    onMenuTypeChange: function onMenuTypeChange() {
      this.modelReload({
        pick: ['parent_id', 'menu_name', 'menu_type', 'order_num', 'remark']
      });
    },

    /**
     * @description 菜单链接改变触发
     * @param {String} url url
     */
    onUrlChange: function onUrlChange(url) {
      var data = (url.indexOf('?') ? url.split('?')[0] : url).split('/').filter(function (s) {
        return s;
      });
      this.modelSet('route_name', data.join('-'));
      this.modelSet('route_path', data.join('/'));
      this.modelSet('route_component', data.join('/'));
    }
  }
};